module.exports = __webpack_public_path__ + "img/xcxd-background.810e523f.jpg";